/* CUSTOM: card box builder
 *
 * Shoppers pick N cards; the box product is added to the cart as one line item with the
 * picks as line item properties. Picks are kept in localStorage so a refresh doesn't lose
 * them (a convenience only; everything works without it).
 */
(function () {
  var root = document.querySelector('[data-card-box]');
  if (!root || root.__dblnInit) return;
  root.__dblnInit = true;

  var size = parseInt(root.getAttribute('data-box-size'), 10) || 12;
  var allowDuplicates = root.getAttribute('data-allow-duplicates') === 'true';
  var variantId = root.getAttribute('data-variant-id');
  var storageKey = root.getAttribute('data-storage-key');

  var items = Array.prototype.slice.call(root.querySelectorAll('[data-card-box-item]'));
  var byId = {};
  items.forEach(function (item) { byId[item.getAttribute('data-id')] = item; });

  var picks = []; // array of card ids, in pick order (repeats allowed)

  var el = function (sel) { return root.querySelector(sel); };
  var slots = el('[data-card-box-slots]');
  var pickedText = el('[data-card-box-picked]');
  var bar = el('[data-card-box-bar]');
  var submit = el('[data-card-box-submit]');
  var submitLabel = el('[data-card-box-submit-label]');
  var clearBtn = el('[data-card-box-clear]');
  var status = el('[data-card-box-status]');
  var errorEl = el('[data-card-box-error]');
  var toggle = el('[data-card-box-toggle]');
  var tray = el('[data-card-box-tray]');

  function save() {
    try { localStorage.setItem(storageKey, JSON.stringify(picks)); } catch (e) {}
  }

  function load() {
    try {
      var saved = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (Array.isArray(saved)) picks = saved.filter(function (id) { return byId[id]; }).slice(0, size);
    } catch (e) { picks = []; }
  }

  function countOf(id) {
    return picks.filter(function (p) { return p === id; }).length;
  }

  function titleOf(id) {
    return byId[id] ? byId[id].getAttribute('data-title') : '';
  }

  function announce(message) {
    status.textContent = '';
    window.setTimeout(function () { status.textContent = message; }, 50);
  }

  function render() {
    var full = picks.length >= size;

    items.forEach(function (item) {
      var id = item.getAttribute('data-id');
      var count = countOf(id);
      var badge = item.querySelector('[data-card-box-count]');
      var add = item.querySelector('[data-card-box-add]');
      var remove = item.querySelector('[data-card-box-remove]');

      item.classList.toggle('is-picked', count > 0);
      badge.hidden = count === 0;
      badge.textContent = count > 1 ? '×' + count : '✓';
      remove.hidden = count === 0;
      add.disabled = full || (!allowDuplicates && count > 0);
      add.textContent = count > 0 && !allowDuplicates ? 'Added' : 'Add';
    });

    slots.innerHTML = '';
    for (var i = 0; i < size; i++) {
      var li = document.createElement('li');
      li.className = 'card-box__slot';
      var id = picks[i];
      if (id) {
        li.classList.add('is-filled');
        var img = document.createElement('img');
        img.src = byId[id].getAttribute('data-image');
        img.alt = '';
        img.width = 80;
        img.height = 80;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'card-box__slot-remove';
        btn.setAttribute('data-slot-index', i);
        btn.setAttribute('aria-label', 'Remove ' + titleOf(id) + ' (card ' + (i + 1) + ')');
        btn.textContent = '×';
        li.appendChild(img);
        li.appendChild(btn);
      } else {
        li.setAttribute('aria-label', 'Empty slot ' + (i + 1));
      }
      slots.appendChild(li);
    }

    pickedText.textContent = picks.length;
    bar.style.width = (picks.length / size * 100) + '%';
    submit.disabled = !full;
    submitLabel.textContent = full ? 'Add box to cart' : 'Pick ' + (size - picks.length) + ' more';
    clearBtn.hidden = picks.length === 0;
    root.classList.toggle('is-full', full);
    save();
  }

  function add(id) {
    if (picks.length >= size) return;
    if (!allowDuplicates && countOf(id) > 0) return;
    picks.push(id);
    render();
    var left = size - picks.length;
    announce(titleOf(id) + ' added. ' + picks.length + ' of ' + size + ' picked.' + (left === 0 ? ' Your box is full.' : ''));
  }

  function removeOne(id) {
    var index = picks.lastIndexOf(id);
    if (index === -1) return;
    picks.splice(index, 1);
    render();
    announce(titleOf(id) + ' removed. ' + picks.length + ' of ' + size + ' picked.');
  }

  root.addEventListener('click', function (event) {
    var addBtn = event.target.closest('[data-card-box-add]');
    var removeBtn = event.target.closest('[data-card-box-remove]');
    var slotBtn = event.target.closest('.card-box__slot-remove');
    var chip = event.target.closest('[data-card-box-chip]');

    if (addBtn) {
      add(addBtn.closest('[data-card-box-item]').getAttribute('data-id'));
    } else if (removeBtn) {
      var item = removeBtn.closest('[data-card-box-item]');
      removeOne(item.getAttribute('data-id'));
      if (removeBtn.hidden) item.querySelector('[data-card-box-add]').focus();
    } else if (slotBtn) {
      var index = parseInt(slotBtn.getAttribute('data-slot-index'), 10);
      var removedId = picks[index];
      picks.splice(index, 1);
      render();
      announce(titleOf(removedId) + ' removed. ' + picks.length + ' of ' + size + ' picked.');
      var next = slots.querySelectorAll('.card-box__slot-remove')[Math.min(index, picks.length - 1)];
      (next || submit).focus();
    } else if (chip) {
      root.querySelectorAll('[data-card-box-chip]').forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      filter();
    }
  });

  // Search + chip filtering (client side; the grid is already on the page)
  var search = el('[data-card-box-search]');
  var empty = el('[data-card-box-empty]');

  function filter() {
    var q = (search.value || '').trim().toLowerCase();
    var activeChip = root.querySelector('[data-card-box-chip][aria-pressed="true"]');
    var group = activeChip ? activeChip.getAttribute('data-card-box-chip') : '';
    var shown = 0;
    items.forEach(function (item) {
      var match = (!q || item.getAttribute('data-title').toLowerCase().indexOf(q) !== -1) &&
        (!group || item.getAttribute('data-groups').indexOf('|' + group + '|') !== -1);
      item.hidden = !match;
      if (match) shown++;
    });
    empty.hidden = shown !== 0;
  }

  if (search) search.addEventListener('input', filter);

  clearBtn.addEventListener('click', function () {
    picks = [];
    render();
    announce('Box cleared. 0 of ' + size + ' picked.');
    submit.focus();
  });

  // Phone/tablet: the tray is a bar at the bottom; this shows/hides the picked slots.
  toggle.addEventListener('click', function () {
    var open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(open));
    toggle.textContent = open ? 'Hide box' : 'Show box';
    tray.classList.toggle('is-open', open);
  });

  submit.addEventListener('click', function () {
    if (picks.length < size) return;

    // Group repeats: "Design 1: Gothic Castle Art Note Card × 2"
    var order = [];
    var counts = {};
    picks.forEach(function (id) {
      if (!counts[id]) { counts[id] = 0; order.push(id); }
      counts[id]++;
    });

    // Customers see "Design N: title × count". The print list for the studio uses properties
    // starting with "_", which Shopify hides in the cart and checkout but shows on the order
    // in the admin: "_Print 01: 6-FAN004-CRD-B-F × 3 (Hummingbird Linen Note Card)".
    var properties = {};
    order.forEach(function (id, i) {
      properties['Design ' + (i + 1)] = titleOf(id) + (counts[id] > 1 ? ' × ' + counts[id] : '');
    });
    order.forEach(function (id, i) {
      var sku = byId[id].getAttribute('data-sku') || 'NO SKU';
      var n = i + 1;
      properties['_Print ' + (n < 10 ? '0' + n : n)] = sku + ' × ' + counts[id] + ' (' + titleOf(id) + ')';
    });
    properties['_Print total'] = picks.length + ' cards, ' + order.length + ' designs';

    // Thumbnails for the cart page/drawer: image path on the store CDN | count.
    properties['_Thumbs'] = order.map(function (id) {
      var src = byId[id].getAttribute('data-image') || '';
      var path = src.split('/cdn/shop/')[1] || '';
      path = path.replace(/[?&]width=\d+/, '');
      return path ? path + '|' + counts[id] : '';
    }).filter(Boolean).join(',');

    submit.disabled = true;
    submitLabel.textContent = 'Adding…';
    errorEl.hidden = true;

    var addUrl = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1, properties: properties }] })
    }).then(function (response) {
      if (!response.ok) throw new Error('add failed');
      picks = [];
      render();
      announce('Your box was added to the cart.');
      // Same event the theme fires after a normal add to cart: refreshes and opens the cart drawer.
      submit.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { button: submit, variant: null, quantity: 1, productAdded: true } }));
    }).catch(function () {
      submit.disabled = false;
      submitLabel.textContent = 'Add box to cart';
      errorEl.textContent = 'Sorry, your box could not be added. Please try again.';
      errorEl.hidden = false;
    });
  });

  load();
  render();

  // ?filter=Halloween (from the collection promos) preselects that filter chip
  var wanted = new URLSearchParams(window.location.search).get('filter');
  if (wanted) {
    root.querySelectorAll('[data-card-box-chip]').forEach(function (c) {
      if (c.getAttribute('data-card-box-chip').toLowerCase() === wanted.toLowerCase()) {
        root.querySelectorAll('[data-card-box-chip]').forEach(function (o) { o.setAttribute('aria-pressed', o === c ? 'true' : 'false'); });
        filter();
      }
    });
  }
})();
